import { ChevronRight } from 'lucide-react';

interface MetricBar {
  label: string;
  value: string;
  level: number;
  color: 'red' | 'green';
}

interface BeforeAfterProps {
  beforeImage?: string;
  afterImage?: string;
  beforeMetrics: MetricBar[];
  afterMetrics: MetricBar[];
}

const MetricDisplay = ({ metric }: { metric: MetricBar }) => (
  <div className="mt-2 sm:mt-3">
    <p className="text-[10px] sm:text-xs text-gray-500">{metric.label}</p>
    <p className="text-[10px] sm:text-xs font-bold text-gray-900">{metric.value}</p>
    <div className="flex gap-0.5 sm:gap-1 mt-1">
      {[1, 2, 3, 4].map(i => (
        <div
          key={i}
          className={`h-1 sm:h-1.5 w-6 sm:w-8 rounded-full ${
            i <= metric.level
              ? metric.color === 'red' ? 'bg-red-500' : 'bg-emerald-500'
              : 'bg-gray-200'
          }`}
        />
      ))}
    </div>
  </div>
);

const BeforeAfterComparison = ({ beforeImage, afterImage, beforeMetrics, afterMetrics }: BeforeAfterProps) => {
  return (
    <div className="flex items-center gap-1.5 sm:gap-2">
      {/* Before card */}
      <div className="flex-1 border border-gray-200 rounded-xl p-3 sm:p-4">
        <div className="flex justify-center mb-2 sm:mb-3">
          <span className="px-2.5 sm:px-3 py-0.5 sm:py-1 bg-red-100 text-red-600 text-[10px] sm:text-xs font-semibold rounded-full">Nu</span>
        </div>
        {beforeImage ? (
          <img src={beforeImage} alt="Huidconditie voor de behandeling" className="w-full aspect-square object-cover rounded-lg" />
        ) : (
          <div className="w-full aspect-square bg-gray-100 rounded-lg flex items-center justify-center">
            <span className="text-3xl sm:text-4xl">👩</span>
          </div>
        )}
        {beforeMetrics.map((m, i) => (
          <MetricDisplay key={i} metric={m} />
        ))}
      </div>

      {/* Arrow */}
      <div className="shrink-0 flex flex-col items-center">
        <div className="text-emerald-500">
          <ChevronRight className="h-6 w-6 sm:h-8 sm:w-8" strokeWidth={3} />
        </div>
      </div>

      {/* After card */}
      <div className="flex-1 border border-emerald-200 rounded-xl p-3 sm:p-4 bg-emerald-50/30">
        <div className="flex justify-center mb-2 sm:mb-3">
          <span className="px-2.5 sm:px-3 py-0.5 sm:py-1 bg-emerald-100 text-emerald-700 text-[10px] sm:text-xs font-semibold rounded-full">Jouw doel</span>
        </div>
        {afterImage ? (
          <img src={afterImage} alt="Huidconditie na de behandeling" className="w-full aspect-square object-cover rounded-lg" />
        ) : (
          <div className="w-full aspect-square bg-emerald-50 rounded-lg flex items-center justify-center">
            <span className="text-3xl sm:text-4xl">🌟</span>
          </div>
        )}
        {afterMetrics.map((m, i) => (
          <MetricDisplay key={i} metric={m} />
        ))}
      </div>
    </div>
  );
};

export default BeforeAfterComparison;